import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import './common/assets/scss/app.scss';
import { Component } from 'vue-property-decorator';
import CssUtils from './common/utils/css.util';
import AppConstants from './common/constants/app.constants';
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);

@Component({
  name: 'App',
  components: {}
})
export default class App extends Vue {
  mounted() {
    CssUtils.setCssVariable(AppConstants.DEFAULT_VIEWPORT_WIDTH_VARIABLE_NAME, AppConstants.DEFAULT_VIEWPORT_WIDTH);
    // ドキュメントのデフォルトのフォント サイズを設定する
    const computedStyle = window.getComputedStyle(document.documentElement);
    const fontSize = computedStyle.getPropertyValue('font-size');
    CssUtils.setCssVariable(AppConstants.DEFAULT_BROWSER_FONT_SIZE_VARIABLE_NAME, fontSize.replace('px', ''));
    this.updateMainViewFontSize();
    // 成功/エラーメッセージのアニメーション時間 (秒)
    CssUtils.setCssVariable(
      AppConstants.ALERT_MESSAGE_ANIMATION_TIME_VARIABLE_NAME,
      AppConstants.ALERT_MESSAGE_ANIMATION_TIME.toString().concat('s')
    );
    // 1 行のデフォルトのメッセージの高さを設定する
    CssUtils.setCssVariable(
      AppConstants.DEFAULT_MESSAGE_HEIGHT_VARIABLE_NAME,
      AppConstants.DEFAULT_MESSAGE_HEIGHT.toString().concat('px')
    );
    window.addEventListener('resize', this.onResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  /**
   * メインビューのフォントサイズを更新します。
   */
  updateMainViewFontSize(): void {
    let mainViewWidth = window.innerWidth;
    if (mainViewWidth < AppConstants.MIN_MAIN_VIEW_WIDTH) {
      mainViewWidth = AppConstants.MIN_MAIN_VIEW_WIDTH;
    }
    CssUtils.setCssVariable(AppConstants.MAIN_VIEW_WIDTH_VARIABLE_NAME, mainViewWidth);
  }

  /**
   * ウィンドウのサイズ変更。
   */
  onResize(): void {
    this.updateMainViewFontSize();
  }

  render() {
    return (
      <div id="app">
        <router-view />
      </div>
    );
  }
}
